import { createStore } from 'react-hookstore';

export const configStore = createStore('configStore', null);
